import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";

/**
 * Admin gate. Layers on top of ProtectedRoute (which already wraps the whole
 * /app subtree): it additionally waits for the admin-allowlist lookup to
 * finish, then redirects non-admins to the dashboard. The redirect is silent —
 * we don't surface a "forbidden" page that would advertise the panel exists.
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { initialized, adminResolved, isSignedIn, isAdmin } = useAuth();
  const location = useLocation();

  if (!initialized || !adminResolved) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "grid",
          placeItems: "center",
          color: "var(--ink-3)",
          fontFamily: "var(--font-mono)",
          fontSize: 12,
        }}
      >
        ●
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
